<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :show-close="false"
    center
    width="40%"
  >
    <dialog-header
      slot="title"
      :title="$t('public.create')"
      :icon="'icon-dialog-add'"
      @close="closeDialog"
    />
    <vue-linetitle style="padding-top:10px">
      <el-row type="flex" justify="center" align="top">
        <el-col :span="24">
          <el-form ref="form" size="mini" :model="formInfo" :rules="rules" :label-position="'right'" 
          :label-width="$t('notice.dialog.labelWidth')">
            <el-form-item :label="$t('notice.dialog.pushTitle') + '：'" prop="title">
              <el-input v-model="formInfo.title" :maxlength="50" :placeholder="$t('notice.dialog.pushTitle')" clearable  />
            </el-form-item>
            <el-form-item :label="$t('notice.dialog.pushContent') + '：'" prop="content">
              <el-input
                v-model="formInfo.content"
                :rows="3"
                :placeholder="$t('notice.dialog.pushContent')"
                :autosize="{ minRows: 6, maxRows: 6}"
                resize="none"
                type="textarea"
                :maxlength="500"
                :show-word-limit="true"/>
            </el-form-item>

            <el-form-item  :label="$t('notice.dialog.pushAll') + '：'" required>
              <el-radio-group v-model="formInfo.isAll">
                <el-radio :label="0">
                  {{ $t('notice.no') }}
                </el-radio>
                <el-radio :label="1">
                  {{ $t('notice.yes') }}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-show="!formInfo.isAll" :label="$t('notice.dialog.selectUsers') +'：'" prop="loginName">
              <el-row type="flex" justify="space-around">
                <el-col :span="20">
                  <div style="position:relative;">
                  <div style="width:100%;height:100%;position:absolute;top:0;left:0;z-index:999;cursor:pointer" @click="visible=true" />
                  <el-input
                    v-model="formInfo.loginName"
                  />
                  
                </div>
                </el-col>
                <el-col :span="4">
                  <el-button style="float:right" class="dialog-cancel" type="primary"
                  @click="selectList=[];formInfo.loginName=''"
                  >{{ $t('public.clear') }}</el-button>
                </el-col>
              </el-row>
                
            </el-form-item>

            

            <el-form-item  :label="$t('notice.notificationType') + '：'" required>
              <el-radio-group v-model="formInfo.notifyType">
                <el-radio :label="6">
                  {{ $t('notice.notificationType6') }}
                </el-radio>
                <el-radio :label="7">
                  {{ $t('notice.notificationType7') }}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            
            
          </el-form>
        </el-col>
      </el-row>
    </vue-linetitle>

    <app-user-list 
    :visibles.sync="visible"
    @select-complete="selectComplete"
    :data="selectList"
    ></app-user-list>

    <div style="height:8px"></div>
    <span slot="footer" class="dialog-footer">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handlecancle">{{$t('public.cancel')}}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{$t('public.define')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
// request
import { createNotice } from '@/api/appManagement/notice'
// 混入
import { partialForm } from '@/mixins/partialForm'
import appUserList from './appUserList'
export default {
  name: 'AddUpdateDialog',
  // components: { appOrganizePicker },
  mixins: [partialForm],
  components: { appUserList },
  props: {
    visibles: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 登录账号
    const title = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('notice.dialog.noTitle')))
      }
    }
    // 真实姓名
    const content = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('notice.dialog.noContent')))
      }
    }
    //
    const loginName = (rule, value, cb) => {
      if (!this.formInfo.loginName) {
        return cb(new Error(this.$t('notice.dialog.noUser')))
      }
    }
    return {
      selectList: [],
      defaultFormInfo: {
        notifyType: 6,
        isAll: 0
      },
      formInfo: {},
      rules: {
        title: [
          { required: true, trigger: ['blur','change'], validator: title }
        ],
        content: [
          { required: true, trigger: ['blur','change'], validator: content }
        ],
        loginName: [
          { required: true, trigger: ['blur','change'], validator: loginName }
        ]
      },
      visible: false
    }
  },
  watch: {
    visibles: {
      handler(e1) {
        if (e1) {
          this.formInfo = { ...this.defaultFormInfo, ...this.data }
        }
      }
    }
  },
  created(){
  },
  methods: {
    // 关闭dialog
    closeDialog() {
      this.formInfo = {...this.defaultFormInfo}
      this.selectList = []
      this.$emit('update:visibles', false)
    },
    // 点击取消
    handlecancle() {
      this.closeDialog()
    },
    // 点击确定
    handleSubmit(){
      const formList = !this.formInfo.isAll ? ['title','content','loginName'] : ['title','content']
      let check = this.checkForm({ formName: 'form',
          formList  })
      if(!check) return
      // eslint-disable-next-line no-unused-vars
      const { loginName, userId, ...postData} = this.formInfo
      !this.formInfo.isAll && (postData.userId = userId) 
      this._createNotice(postData)
    },

    // 新增
    _createNotice(postData) {
      createNotice(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    selectComplete(data){
      this.selectList = data 
      this.formInfo.loginName = data.map(item=>item.loginName).join(',')
      this.formInfo.userId = data.map(item=>item.appUserId)
    }
   
  }
}
</script>
<style lang="scss">
// .textareaStyle textarea{
//   height: 80px!important;
// }
</style>
